/**
 * Post-login redirect targets come from the URL, so they must never be able to
 * send a freshly authenticated user to another origin. Only same-origin,
 * path-relative targets are accepted.
 */
export const safeRedirect = (
  value?: string
): string | undefined => {
  if (!value?.startsWith("/")) {
    return undefined;
  }

  // "//host" and "/\host" are both protocol-relative in browsers.
  const second = value[1];
  if (second === "/" || second === "\\") {
    return undefined;
  }

  return value;
};
